import { BaseTariffPage } from "@/components/tarif/BaseTariffPage";
import { Shield, Lock, Users, AlertTriangle, CheckCircle, FileText, Building2, Stethoscope, Hospital } from "lucide-react";

const WUERTTEMBERGISCHE_COLOR = "#E66000";

const WuerttembergischeTarif = () => {
  return (
    <BaseTariffPage
      companyName="Württembergische"
      companyColor={WUERTTEMBERGISCHE_COLOR}
      productRating={{ value: 4.7, count: 356 }}
      priceRange="50-190"
      pageTitle="Württembergische Cyberversicherung für Arztpraxen | Zuverlässiger Cyberschutz"
      metaDescription="Württembergische Cyberversicherung - Umfassender Schutz für Arztpraxen, MVZ und Kliniken. Professionelle Absicherung gegen Cyberrisiken mit erstklassigem Service."
      metaKeywords="Württembergische Cyberversicherung, Arztpraxis, MVZ, Klinik, Cyberschutz, Datenschutz, IT-Sicherheit"
      canonicalUrl="https://praxis-versichert.de/tarifwissen/wuerttembergische"
      heroLabel="Württembergische Cyberversicherung"
      heroTitle="Württembergische Cyberversicherung"
      heroDescription="Zuverlässiger Cyberschutz für Arztpraxen, MVZ und Kliniken"
      heroFeatures={[
        {
          icon: Shield,
          title: "Bis zu 10 Mio. € Deckung",
          subtitle: "Höchster Schutz für Ihre Einrichtung"
        },
        {
          icon: Lock,
          title: "Cyber-Rundum-Schutz",
          subtitle: "Erste- und Drittschäden vollständig versichert"
        },
        {
          icon: Users,
          title: "24/7 Cyber-Helpdesk",
          subtitle: "Sofortige Unterstützung im Ernstfall"
        }
      ]}
      alertTitle="Württembergische Cyberversicherung"
      alertDescription="Die Württembergische bietet maßgeschneiderte Cyberversicherungslösungen für medizinische Einrichtungen mit besonderem Fokus auf präventive Sicherheitsmaßnahmen und schnelle Schadensregulierung."
      coverageAreas={[
        {
          icon: Shield,
          title: "Cyber-Eigenschäden",
          items: [
            "Datenrettung und IT-Forensik",
            "Wiederherstellung von Systemen und Daten",
            "Betriebsunterbrechungsschäden",
            "Cyber-Erpressungsschäden"
          ]
        },
        {
          icon: Lock,
          title: "Cyber-Haftpflicht",
          items: [
            "Datenschutz-Haftpflicht (DSGVO-Verstöße)",
            "Schadensersatzansprüche Dritter",
            "Kosten für Patienteninformation",
            "Rechtsverteidigungs- und Anwaltskosten"
          ]
        },
        {
          icon: AlertTriangle,
          title: "Cyber-Assistance",
          items: [
            "24/7 Cyber-Notfall-Hotline",
            "IT-Sicherheitsexperten vor Ort",
            "Krisenkommunikation und PR",
            "Psychologische Erstbetreuung"
          ]
        }
      ]}
      targetGroups={[
        {
          icon: Stethoscope,
          title: "Hausarztpraxen",
          description: "Optimal abgestimmter Schutz für Allgemeinmediziner mit digitaler Patientenverwaltung.",
          benefits: [
            "Schutz elektronischer Patientenakten",
            "Absicherung der Praxisverwaltungssoftware",
            "Betriebsunterbrechungsschutz"
          ],
          recommendation: "Empfohlene Deckungssumme: 1-3 Mio. €"
        },
        {
          icon: Building2,
          title: "Fachärzte",
          description: "Speziallösungen für Facharztpraxen mit medizintechnischen Geräten und Bildgebung.",
          benefits: [
            "Schutz vernetzter Medizintechnik",
            "Absicherung bildgebender Systeme",
            "Erweiterte IT-Forensik"
          ],
          recommendation: "Empfohlene Deckungssumme: 3-5 Mio. €"
        },
        {
          icon: Hospital,
          title: "MVZ & Kliniken",
          description: "Umfassende Versicherungslösungen für große medizinische Einrichtungen.",
          benefits: [
            "Höchste Deckungssummen bis 10 Mio. €",
            "Schutz komplexer IT-Infrastrukturen",
            "Spezialisiertes Krisenmanagement"
          ],
          recommendation: "Empfohlene Deckungssumme: 5-10 Mio. €"
        }
      ]}
      insuranceConditions={[
        {
          icon: CheckCircle,
          title: "Versicherungssumme",
          description: "Flexible Deckungssummen von 1 Mio. € bis 10 Mio. € - individuell anpassbar an Ihre Praxisgröße"
        },
        {
          icon: Shield,
          title: "Selbstbehalt",
          description: "Wahlweise 0 €, 500 €, 1.000 € oder 2.500 € - attraktive Prämienrabatte bei höherem Selbstbehalt"
        },
        {
          icon: FileText,
          title: "Wartezeit",
          description: "Keine Wartezeit - Versicherungsschutz beginnt sofort mit Vertragsbeginn"
        },
        {
          icon: AlertTriangle,
          title: "Nachhaftung",
          description: "24 Monate Nachhaftung bei Vertragsende für bereits eingetretene Schäden"
        },
        {
          icon: Lock,
          title: "IT-Sicherheitsanforderungen",
          description: "Aktuelle Antivirensoftware, Firewall, regelmäßige Updates und verschlüsselte Backups erforderlich"
        },
        {
          icon: Users,
          title: "Präventionsleistungen",
          description: "Kostenlose IT-Sicherheitschecks, Mitarbeiterschulungen und Cyber-Risikoanalyse inklusive"
        }
      ]}
      faqs={[
        {
          question: "Was unterscheidet die Württembergische von anderen Cyberversicherungen?",
          answer: "Die Württembergische bietet besonders hohe Deckungssummen bis 10 Mio. €, umfassende Präventionsleistungen und einen 24/7 Cyber-Helpdesk mit direktem Zugang zu IT-Forensik-Experten. Zudem ist die Schadensregulierung sehr schnell und unkompliziert."
        },
        {
          question: "Sind auch Schäden durch Mitarbeiterfehler versichert?",
          answer: "Ja, fahrlässiges Verhalten von Mitarbeitern wie das Öffnen von Phishing-Mails ist mitversichert. Nur vorsätzliche oder grob fahrlässige Handlungen sind vom Versicherungsschutz ausgeschlossen."
        },
        {
          question: "Wie schnell greift der Versicherungsschutz im Notfall?",
          answer: "Der Versicherungsschutz beginnt sofort mit Vertragsbeginn ohne Wartezeit. Im Schadensfall erreichen Sie die 24/7 Notfall-Hotline jederzeit, IT-Experten werden bei akuten Vorfällen innerhalb weniger Stunden vermittelt."
        },
        {
          question: "Werden auch präventive Maßnahmen unterstützt?",
          answer: "Ja, die Württembergische bietet kostenlose IT-Sicherheitschecks, Mitarbeiterschulungen zu Cyber-Risiken und regelmäßige Risikoanalysen als Präventionsleistungen an."
        },
        {
          question: "Was passiert, wenn ein Bußgeld wegen DSGVO-Verstoß verhängt wird?",
          answer: "Soweit versicherbar übernimmt die Württembergische auch behördlich verhängte Bußgelder aufgrund von Datenschutzverstößen, sofern diese nicht vorsätzlich herbeigeführt wurden."
        },
        {
          question: "Ist eine Nachhaftung bei Vertragsende vorgesehen?",
          answer: "Ja, die Württembergische gewährt eine Nachhaftung von 24 Monaten für Schäden, die während der Vertragslaufzeit eingetreten, aber erst nach Vertragsende gemeldet werden."
        }
      ]}
      documents={[
        {
          title: "Württembergische Produktinformation Cyber",
          type: "PDF",
          url: "/erstinformation.pdf"
        },
        {
          title: "Versicherungsbedingungen Cyberversicherung",
          type: "PDF",
          url: "/erstinformation.pdf"
        },
        {
          title: "Antrag Cyberversicherung",
          type: "PDF",
          url: "/erstinformation.pdf"
        }
      ]}
    />
  );
};

export default WuerttembergischeTarif;
